import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@sdbn/appclient';
import { Identity } from '@sdbn/appclient';
import { ServiceResponse } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { Transport } from 'src/tmc-yard/common/model/transport.model';
import { EditTransport } from '../edit-transport.model';

@Injectable({
  providedIn: 'root'
})
export class EditTransportService {

  constructor(private http: HttpService) { }

  getTransport(identity: Identity): Observable<Transport> {
    return this.http.postWithContext<Transport>(`${environment.changeTransportEndpoint}/get`, identity);
  }

  save(editTransport: EditTransport): Observable<ServiceResponse> {
    return this.http.postWithContext(`${environment.changeTransportEndpoint}/save`, editTransport);
  }

  findCarriersStartingByName(name: string): Observable<string[]> {
    return this.http.postWithContext(`${environment.changeTransportEndpoint}/carriers-by-name`, name);
  }

  findString1StartingWith(name: string): Observable<string[]> {
    return this.http.postWithContext(`${environment.changeTransportEndpoint}/string1`, name);
  }

  findNumberPlatesStartingWith(name: string): Observable<string[]> {
    return this.http.postWithContext(`${environment.transportRegistrationEndpoint}/numberplates`, name);
  }

}
